import { SymbolLayerSpecification } from 'mapbox-gl';

import { FeatureTypeEnum, LayerNameEnum, SourceNameEnum } from '@/types/map.types';

export const clusterIconLayer: SymbolLayerSpecification = {
  type: 'symbol',
  id: LayerNameEnum.VERTIPORTS,
  source: SourceNameEnum.VERTIPORTS,
  layout: {
    'icon-image': ['get', 'imageId'],
    'icon-size': 1,
    'icon-allow-overlap': true,
  },
};

export const fatoIconLayer: SymbolLayerSpecification = {
  type: 'symbol',
  id: LayerNameEnum.FATO,
  source: SourceNameEnum.VERTIPORTS,
  filter: [
    'all',
    ['==', ['get', 'featureType'], FeatureTypeEnum.FATO_ICON],
    ['!', ['has', 'cluster']],
    ['!', ['has', 'point_count']],
  ],
  layout: {
    'icon-image': ['get', 'icon'],
    'icon-size': 0.8,
    'icon-anchor': 'center',
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'text-field': ['get', 'label'],
    'text-font': ['roboto'],
    'text-size': 14,
    'text-offset': [0, 0.1],
    'text-allow-overlap': true,
    'text-ignore-placement': true,
  },
};
